<template>
  <div :class="{ active: !secondaryMarket || !isFundRaising }" class="tab-pane fade show" id="common"
       role="tabpanel" aria-labelledby="common-tab">
<!--    <section class="borrower-info">-->
<!--      <h3>Заемщик</h3>-->
<!--      <div class="template__text template__budget">-->
<!--        <div class="template__row" v-if="project.general.inn">-->
<!--          <div class="template__row__left">ИНН</div>-->
<!--          <div class="template__row__right">{{ project.general.inn }}</div>-->
<!--        </div>-->
<!--        <div class="template__row" v-if="project.general.kpp">-->
<!--          <div class="template__row__left">КПП</div>-->
<!--          <div class="template__row__right">{{ project.general.kpp }}</div>-->
<!--        </div>-->
<!--        <div class="template__row" v-if="project.general.ogrn">-->
<!--          <div class="template__row__left">ОГРН(ИП)</div>-->
<!--          <div class="template__row__right">{{ project.general.ogrn }}</div>-->
<!--        </div>-->
<!--        <div class="template__row">-->
<!--          <div class="template__row__left">Адрес регистрации</div>-->
<!--          <div class="template__row__right">{{ project.general.address }}</div>-->
<!--        </div>-->
<!--        <div class="template__row">-->
<!--          <div class="template__row__left">Дата регистрации</div>-->
<!--          <div class="template__row__right">-->
<!--            <date-format :date="project.general.borrowerCreatedAt"/>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="template__row">-->
<!--          <div class="template__row__left">Единоличный исполнительный орган/Генеральный директор/Учредители</div>-->
<!--          <div>-->
<!--            <div v-for="(guarantor, key) in project.guarantors" :key="key" class="check">-->
<!--              {{ guarantor.fullName }} – {{ guarantor.share }}%-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->
<!--    <section class="goal">-->
<!--      <h3>Цель</h3>-->
<!--      <p class="template__text" v-html="project.general.loanPurpose"></p>-->
<!--    </section>-->
    <div class="block-common-info">
      <div v-if="project.general.siteUri">
        <i class="bi-link-45deg"></i>
        <a :href="project.general.siteUri" target="_blank">
          {{ siteUrlHost }}
        </a>
      </div>
      <div v-html="project.general.projectFeatures"></div>
      <h3>Результаты проверки</h3>
      <div v-if="project.checks" class="check-list template__text">
        <div v-for="(check, key) in checksList" :key="key" class="check">
          <div class="check__name">{{ check.name }}</div>
          <div>{{ check.value }}</div>
          <div>
            <a v-for="(link, index) in check.links" :key="index" :href="link" target="_blank" class="check__link">Смотреть</a>
          </div>
        </div>
      </div>
      <div v-if="project.general.companyFiles.length">
        <h3>Вложения</h3>
        <div v-for="document in project.general.companyFiles" :key="document.id" class="mt-2">
          <a :href="document.url" target="_blank template__text">
            <i class="bi-file-earmark-arrow-down"></i>
            {{ document.name }}
          </a>
        </div>
      </div>
      <div v-if="project.general.companyLinks">
        <h3>Подробнее о проекте</h3>
        <div class="template__text" v-html="project.general.companyLinks"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {DateFormat} from "@/components/common";

export default {
  name: "DetailedProjectCommonInfo",
  components: {DateFormat},
  props: {
    project: {
      type: Object,
      required: true
    },
    secondaryMarket: {
      type: Boolean,
      required: true
    },
    isFundRaising: {
      type: Boolean,
      required: true
    },
    siteUrlHost: {
      type: String,
      required: true
    }
  },
  computed: {
    checksList() {
      const checks = [];
      const checkTypes = [
        {key: 'checkBankruptcy', label: 'Проверка на банкротство'},
        {key: 'checkCourt', label: 'Суды'},
        {key: 'checkEnforcementProceedings', label: 'Исполнительное производство'},
        {key: 'checkRegister', label: 'Реестр недобросовестных поставщиков'},
        {key: 'checkAuction', label: 'Участие в торгах'}
      ];
      checkTypes.forEach(({key, label}) => {
        if (this.project.checks[key] || this.project.checks[key + 'Link']) {
          checks.push({
            name: label,
            value: this.project.checks[key],
            links: [this.project.checks[key + 'Link']].filter(Boolean)
          });
        }
      });
      console.log(this.project)
      return checks.concat(this.project.checks.checks || []);
    }
  }
};
</script>

<style lang="scss" scoped>
.block-common-info {
  .check {
    display: grid;
    grid-template-columns: 1.5fr 1fr 1fr;

    &__name {
      color: #6c757d;
      font-weight: normal;
    }

    &__link {
      color: var(--primary-green-color-hover)
    }
  }

  .check-list {
    margin-top: 1rem;
  }
}

h3, h4, p {
  text-align: left;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"
}


p, .template__text {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
}

.template__row {
  display: grid;
  grid-template-columns: 1fr 1fr;

  &__left {
    color: #6c757d;
    font-weight: normal;
  }
}

h3 {
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.2;
  margin-block: 1.5rem 0.5rem;
}

h4 {
  color: #6c757d;
  font-size: 0.875rem;
  margin-block: 0.5rem 0.5rem;
  font-weight: 500;
}

</style>
